import { supabase } from '../config/supabaseConfig.ts';

export const ticketService = {
  getAll: async () => {
    try {
      const { data, error } = await supabase
        .from('ticket')
        .select('*, project_id(*)')
        .order('created_at', { ascending: false });
      
      if (error) {return {data: null, error};};
      return {data, error};
    } catch (error) {
      console.error('Error al obtener tickets:', error);
      return {data: null, error};
    }
  },

  closeTicket: async (ticketId) => {
    try {
      const { data, error } = await supabase
        .from('ticket')
        .update({
          status: 'closed',
          closed_date: new Date()
        })
        .eq('id', ticketId)
        .select()
        .single();
      
      if (error) {return {data: null, error};};
      return {data, error};
    } catch (error) {
      console.error('Error al cerrar ticket:', error);
      return {data: null, error};
    }
  },

  mostTicketsOPen: async () => {
    try {
      const { data, error } = await supabase
        .from('project')
        .select('*, ticket(status)');
      
      if (error) {return {data: null, error};};
      
      // Calculate open tickets count for each project
      const projectsWithCount = data.map(project => {
        const openCount = project.ticket ? project.ticket.filter(t => t.status === 'open').length : 0;
        return { ...project, openTicketsCount: openCount };
      });

      // Sort by open tickets count descending
      projectsWithCount.sort((a, b) => b.openTicketsCount - a.openTicketsCount);

      // Get the one with most open tickets
      const mostBusyProject = projectsWithCount.length > 0 ? projectsWithCount[0] : null;
      return {data: mostBusyProject, error};
    } catch (error) {
      console.error('Error al obtener tickets:', error);
      return {data: null, error};
    }
  },

  fetchTicketsByType: async () => {
    try {
      const { data, error } = await supabase
        .from('ticket')
        .select('type')
        .order('created_at', { ascending: false });
      
      if (error) {return {data: null, error};};

      const counts = { bug: 0, improvement: 0 };
      
      data.forEach(ticket => {
        if (ticket.type === 'bug') {
          counts.bug++;
        } else if (ticket.type === 'improvement' || ticket.type === 'mejora') {
          counts.improvement++;
        }
      });

      const total = data.length;
      
      const result = [
        { 
          id: 'improvement',
          label: 'Mejora', 
          count: counts.improvement, 
          color: 'bg-blue-500', 
          percentage: total > 0 ? (counts.improvement / total) * 100 : 0 
        },
        { 
          id: 'bug',
          label: 'Bug', 
          count: counts.bug, 
          color: 'bg-red-500', 
          percentage: total > 0 ? (counts.bug / total) * 100 : 0 
        }
      ];

      return {data: result, error};
    } catch (error) {
      console.error('Error al obtener tickets:', error);
      return {data: null, error};
    }
  },

  fetchTicketsBySeverity: async () => {
    try {
      const { data, error } = await supabase
        .from('ticket')
        .select('severity');
      
      if (error) {return {data: null, error};};

      const counts = { low: 0, medium: 0, high: 0 };
      
      data.forEach(ticket => {
        if (counts[ticket.severity] !== undefined) {
          counts[ticket.severity]++;
        }
      });

      const total = data.length;
      
      const result = [
        { 
          id: 'low',
          label: 'Bajo', 
          count: counts.low, 
          color: 'bg-green-500', 
          percentage: total > 0 ? (counts.low / total) * 100 : 0 
        },
        { 
          id: 'medium',
          label: 'Medio', 
          count: counts.medium, 
          color: 'bg-yellow-500', 
          percentage: total > 0 ? (counts.medium / total) * 100 : 0 
        },
        { 
          id: 'high',
          label: 'Alto', 
          count: counts.high, 
          color: 'bg-red-600', 
          percentage: total > 0 ? (counts.high / total) * 100 : 0 
        }
      ];

      return {data: result, error};
    } catch (error) {
      console.error('Error al obtener tickets por gravedad:', error);
      return {data: null, error};
    }
  },

  fetchTicketsByProject: async () => {
    try {
      const { data, error } = await supabase
        .from('project')
        .select('name, ticket(status)');
      
      if (error) {return {data: null, error};};

      const result = data.map(project => {
        let open = 0;
        let closed = 0;

        if (project.ticket) {
          project.ticket.forEach(t => {
            if (t.status === 'open') open++;
            else if (t.status === 'closed') closed++;
          });
        }

        return {
          name: project.name,
          open,
          closed,
          total: open + closed
        };
      }).filter(item => item.total > 0);

      result.sort((a, b) => b.total - a.total);

      return {data: result, error};
    } catch (error) {
      console.error('Error al obtener tickets por proyecto:', error);
      return {data: null, error};
    }
  }

}  